import React, { FC, PropsWithChildren, useEffect } from "react";
import { Elements, RecurlyProvider, useRecurly } from "@recurly/react-recurly";

import {
  RecurlyFraudConfigWrapperProp,
  WrappedRecurlyProviderProps,
} from "./types";

const RecurlyFraudConfigWrapper: FC<PropsWithChildren<
  RecurlyFraudConfigWrapperProp
>> = ({ children, publicKey }) => {
  const recurlyJS = useRecurly();

  useEffect(() => {
    recurlyJS?.configure?.({
      publicKey,
      fraud: {
        kount: {
          dataCollector: true,
        },
      },
    });
  }, [publicKey, recurlyJS]);

  return <>{children}</>;
};

export const WrappedRecurlyProvider: FC<PropsWithChildren<
  WrappedRecurlyProviderProps
>> = ({ children, publicKey }) => {
  if (publicKey) {
    return (
      <RecurlyProvider publicKey={publicKey}>
        <Elements>
          <RecurlyFraudConfigWrapper publicKey={publicKey}>
            {children}
          </RecurlyFraudConfigWrapper>
        </Elements>
      </RecurlyProvider>
    );
  }

  return <>{children}</>;
};
